import Dialog from '@mui/material/Dialog';
/* eslint-disable */

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Alert from '@mui/material/Alert';

const VerificationConfirmationDialog = ({ open, onClose, onConfirm, title, content, type }) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
                sx: {
                    minWidth: { md: '500px', sm: '100%' },
                    minHeight: { md: '200px', sm: 'auto' },
                    p: 2
                }
            }}
        >
            <DialogTitle id="responsive-dialog-title" sx={{ fontSize: '1.5rem' }}>
                {title || 'Confirmation'}
            </DialogTitle>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography sx={{ fontSize: '1.2rem' }}>{content || 'Are you sure you want to verify this beneficiary?'}</Typography>
                {!type === 'esaf' && (
                    <Alert severity="info" sx={{ width: '100%', '& .MuiAlert-message': { fontSize: '1rem' } }}>
                        A verification charge of ₹4 will be applicable and will be debited from your wallet
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="error" size="large" sx={{ fontSize: '1rem', px: 3 }}>
                    No
                </Button>
                <Button onClick={onConfirm} color="primary" size="large" sx={{ fontSize: '1rem', px: 3 }}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VerificationConfirmationDialog;
